import { styled } from 'baseui'

export const LoaderCard = styled('div', {
  width: '100%',
  padding: '2.5rem 2rem',
  backgroundColor: '#fff',
  borderRadius: '1rem',
  minHeight: '6.25rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const LoaderContent = styled('div', {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'center',
})

export const LoaderText = styled('span', {
  marginLeft: '1.1rem',
  fontSize: '1.1rem',
  color: '#7B868C',
  fontWeight: 400,
  lineHeight: 1,
})
